import * as t from "io-ts";
export const logEntryLevelT = t.union([
    t.literal("info"),
    t.literal("warning"),
    t.literal("error"),
]);
const knownLogReportFields = {
    msg: t.string,
    message: t.string,
    err: t.unknown,
    args: t.unknown,
    action: t.unknown,
    input: t.unknown,
    context: t.unknown,
    event: t.string,
    eventId: t.string,
    componentStack: t.string,
    actionType: t.string,
    type: t.string,
    userId: t.string,
    sessionId: t.string,
};
export const logReportT = t.exact(t.partial(knownLogReportFields));
export const logEntryT = t.exact(t.intersection([
    t.type({ level: logEntryLevelT }),
    t.partial(knownLogReportFields),
]));
export const bulkLogEntriesT = t.type({
    entries: t.array(logEntryT),
});
//# sourceMappingURL=log-entries.js.map